import {useState} from 'react'
import { useNavigate } from "react-router-dom";

import Password from '../../components/ui/Input/Password'
import Input from "../../components/ui/Input/Input";
import Button from "../../components/ui/Button";
import CabecalhoForm from "../../components/ui/CabecalhoForm";
import SelectBox from "../../components/ui/SelectBox";
import {API_URL} from '../../config/api'


import { FaCheck } from "react-icons/fa";



import './CadastroUsuario.css'
import { SiOpenhab } from 'react-icons/si';
export default function CadastroUsuario(){
    const [name, setName] = useState()
    const [email, setEmail] = useState()
    const [password, setPassword] = useState("")
    const [location, setLocation] = useState()
    const [passwordInvalid, setPasswordInvalid] = useState(null)

    const [mensagemErro, setMensagemErro] = useState()

    const navigate = useNavigate()

    const verificaSenha = () => {
        return {
            tamanho: password.length >= 10,
            maiuscula: /[A-Z]/.test(password),
            minuscula: /[a-z]/.test(password),
            especial: /[^A-Za-z0-9]/.test(password),
        };
    };

    const CadastrarUsuario = async()=>{
        
        const validacao = verificaSenha()
        console.log(validacao)

        if(!validacao.tamanho || !validacao.especial || !validacao.maiuscula || !validacao.minuscula){
            setPasswordInvalid(true)
            return
        }
        else{
            setPasswordInvalid(false)
        }

        try {
            const dados = {
                name: name,
                email: email,
                password: password,
                location: location
            };

            const response = await fetch(
                `${API_URL}/auth/createUser`,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(dados)
                }
            );

            if (response.ok) {
                const data = await response.json();

                localStorage.setItem("token", data.token);

                navigate('/login');
                return;
            }
            else {
                const errorMessage = await response.text();
                setMensagemErro(errorMessage); 
            }

        } catch (error) {
            console.error(error);
            setMensagemErro(
                "Não foi possível conectar ao servidor. Tente novamente."
            );
        }
    }

    return (

        <div className="telaCadastro">

           <div className="formCadastro">

                <CabecalhoForm textTyping="Semana da TI" />

                <Input 
                    name="nome" 
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                    placeholder='Digite seu nome'
                    label="Nome"
                    />
                    <SelectBox 
                        value={location}
                        onChange={(e)=>setLocation(e.target.value)}
                        options={[
                                {id:1, nome: "Atlantic Nickel"}, 
                                {id:2, nome: "Omnigen"}, 
                                {id:3, nome: "Graphcoa"}, 
                                {id:4, nome: "Escritório BH"} ]}
                        label="Empresa"
                    />
                <Input 
                    name="email" 
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    placeholder='Digite seu e-mail corporativo'
                    label="E-mail corporativo"
                    />
                <Password 
                    name="senha" 
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    placeholder='Digite sua senha'
                    type="password"
                    label="Senha"
                    />
                <span className={passwordInvalid ? "senhaInvalida" : "orientacaoSenha" }>
                        {passwordInvalid !== null && !passwordInvalid ? <FaCheck size={15} color="var(--verde)"/> : ""}
                        Use no mínimo 10 caracteres, incluindo 1 letra maiúscula, 1 letra minúscula e 1 caractere especial.
                        
                </span>
                
                {mensagemErro && <p className="erroMensagem">{mensagemErro}</p>}
                <Button onClick={CadastrarUsuario} text='Cadastrar' className="btnAmarelo"/>
           </div>
        </div>
    )
}